import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import * as serviceWorker from './serviceWorker';
import { store, persistor } from './store';
import './index.scss';

const App = React.lazy(() => import('./App'));

const {
  REACT_APP_GTM_CONTAINER_ID: GTM_ID,
} = process.env;

const tagManagerArgs = {
  gtmId: GTM_ID
}

if (tagManagerArgs.gtmId?.length > 0 ) {
  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Suspense fallback={<></>}>
          <App />
        </Suspense>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root_react')
);

serviceWorker.unregister();
